import Mock from 'mockjs'

// 商品列表
const MOCK050020 = Mock.mock({
    'respCode': '0000',
    'respMsg': '',
    'respData': {
        'orders|10-20': [{
            'orderNo': '@id',
            'purchaserName': '@cname(5)',
            'supplierName': '@cname(5)',
            'orderAcctName': '@cname(5)',
            'orderTm': '@datetime',
            'itemCount|100-300': 100,
            'priceType': 'A',
            'priceTypeDisp': '战略采购价',
            'orderAmountTotal|5000-10000': 5000,
            'orderStatus': '01',
            'bOrderStatusDisp': '待供应商确认订单',
            'sOrderStatusDisp': '采购商已下单，待确认订单',
        }],
        'pageSize|10-20': 10,
        'totalCount|100-500': 100
    }
});

export default MOCK050020


// WEBPACK FOOTER //
// ./src/mock/getOrderList.js